"use client"

import Link from "next/link"
import {usePathname} from "next/navigation"
import {getContextLinks} from "@/app/utils/context-utils"

// Contextual footer links depend on the current pathname. Reading it via the
// client hook usePathname() (instead of the server headers() API) keeps the
// pages that render the shared Footer statically rendered / ISR. For a static
// route the pathname is known at build time, so the correct links are baked
// into the prerendered HTML — no SEO regression.
export default function FooterContextLinks() {
    const pathname = usePathname()
    const linksToDisplay = getContextLinks(pathname ?? "")

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 w-full gap-8 md:gap-4">
            {Object.keys(linksToDisplay).map((category, index) => (
                <div className="flex flex-col gap-[12px]" key={index}>
                    <div>
                        <span className="p-1.5 bg-rm-blue w-fit rounded-md title-look leading-[2.05rem]">{category}</span>
                    </div>

                    <ul className="flex flex-col gap-2">
                        {linksToDisplay[category].map((link, index) => (
                            <li key={index}>
                                <Link className="hover:underline" href={link.url}>
                                    {link.text}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    )
}
